export const WorkIcon = ({ ...props }: any) => (
  <svg width={16} height={16} fill="none" {...props}>
    <path
      stroke="var(--color-icon-bright)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m8.247 1.435 6 2.4c.234.093.42.373.42.62v2.213c0 .367-.3.667-.666.667H2a.669.669 0 0 1-.667-.667V4.455c0-.247.187-.527.42-.62l6-2.4a.78.78 0 0 1 .493 0ZM14.667 14.667H1.334v-2c0-.367.3-.667.667-.667h12c.366 0 .666.3.666.667v2ZM2.666 11.999V7.332M5.334 11.999V7.332M8 11.999V7.332M10.666 11.999V7.332M13.334 11.999V7.332M.666 14.668h14.667"
    />
    <path
      stroke="var(--color-icon-bright)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M8 5.668a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
);
